<template>
  <span>
    <b-modal
      size="sm"
      v-model="modal"
      @hide="hideModal"
      title="Brecha Operacional"
    >
      <div class="text-center">
        <b-alert show
          >CREANDO DESDE {{ lotComputed }}-{{ product_name }}<br /><b
            >{{ differenceComputed }} Kg RESTANTES</b
          ></b-alert
        >
        <h4>¿Quieres cuadrar el proceso?</h4>
        <p>
          Se asignarán <b class="font-lg">{{ differenceComputed }} Kg</b> a
          BRECHA OPERACIONAL
        </p>
      </div>

      <b-form-group
        label-cols-sm="12"
        label-cols-lg="12"
        label="Orden Fabricación"
      >
        <b-form-input
          type="text"
          required
          autocomplete="off"
          v-model="manufacturing_order"
          v-on:keyup="inputSoloNumero"
        >
        </b-form-input>
      </b-form-group>

      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            :disabled="loading === true"
            @click.prevent="
              e => {
                e.target.blur();
                onSubmit();
              }
            "
            @keydown="$event.keyCode === 13 ? $event.preventDefault() : false"
            class="float-right ml-1"
            >Si
            <b-spinner v-if="loading" class="float-right" small />
          </b-button>
          <b-button class="float-right ml-1" @click="hideModal"
            >Cancelar</b-button
          >
        </div>
      </template>
    </b-modal>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import { decimal, minValue, required } from "vuelidate/lib/validators";

export default {
  name: "BrechaComercialButton",
  props: {
    lot: {
      type: String,
      default: ""
    },
    lot_id: {
      type: Number,
      default: 0
    },
    fruit_id: {
      type: Number,
      default: 0
    },
    modal: {
      type: Boolean,
      default: false
    },
    product_id: {
      type: Number,
      default: 0
    },
    product_name: {
      type: String,
      default: 0
    },
    product_code: {
      type: String,
      default: 0
    },
    net_kilograms_sum_in: {
      type: String,
      default: 0
    },
    net_kilograms_sum_out: {
      type: String,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      manufacturing_order: ""
    };
  },
  computed: {
    ...mapGetters("bagnoProcessModule", [
      "totalInNet",
      "totalInGross",
      "totalOutNet",
      "totalOutGross",
      "totalQuantitySaleable",
      "totalSaleable"
    ]),
    commercialDiff() {
      return this.difference(
        this.form.box_avg * this.totalQuantitySaleable,
        this.totalSaleable
      );
    },
    lotComputed() {
      return this.lot;
    },
    lotId() {
      return this.lot_id;
    },
    productId() {
      return this.product_id;
    },
    differenceComputed() {
      return (this.net_kilograms_sum_in - this.net_kilograms_sum_out).toFixed(
        2
      );
    }
  },
  methods: {
    difference(a, b) {
      return (a - b).toFixed(2);
    },
    hideModal() {
      this.$emit("hideOperationalModal");
    },
    resetForm() {
      this.manufacturing_order = null;
    },
    async addRowsOut() {
      if (this.manufacturing_order != "") {
        const thisV = this;
        thisV.loading = true;
        const data = {
          net_kilograms: this.differenceComputed,
          gross_kilograms: 0,
          process: thisV.$route.params.id,
          lot: thisV.lot_id,
          quantity: 0,
          fruit_id: thisV.fruit_id,
          product_code: thisV.product_code,
          product_name: thisV.product_name,
          waste_type: "BRECHA OPERACIONAL",
          container: "-",
          product_id: thisV.product_id,
          is_devolution: false,
          manufacturing_order: parseInt(thisV.manufacturing_order)
        };

        try {
          const response = await thisV.$axios({
            method: "POST",
            url: `bagno/process/${thisV.$route.params.id}/square_up_process/`,
            data: data
          });
          if (response.data.status != "0") {
            thisV.$store.dispatch(
              "bagnoProcessModule/addRowsOut",
              response.data
            );
            thisV.$toast.success(`Brecha operacional creada con éxito`, "");
            thisV.loading = false;
            thisV.hideModal();
            thisV.resetForm();
          } else {
            thisV.$toast.error(
              "Problemas al crear, tipo de producto no encontrado",
              ""
            );
            thisV.loading = false;
          }
        } catch (error) {
          console.log(error);
          thisV.$toast.error("Problemas al crear", "");
          thisV.loading = false;
          thisV.resetForm();
        }
      } else {
        this.$toast.info(`Debe ingresar una orden fabricación`, "");
      }
    },
    onSubmit() {
      this.addRowsOut();
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    }
  }
};
</script>

<style scoped></style>
